module.exports = __webpack_public_path__ + "static/media/rd_name.e46a9642.svg";